import moment from 'moment'
import 'moment/locale/es-mx'

const MIN_DATE_MONTH = moment('2022-08-01').startOf('month').format()
const MIN_DATE_MONTH_EXTRANET = moment('2022-08-01').startOf('month').format()
const MIN_DATE = moment('2022-08-01').format()

export {
  MIN_DATE_MONTH,
  MIN_DATE,
  MIN_DATE_MONTH_EXTRANET
}
